import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { CallToActionMessage } from '../call-to-action-message';
import { messages } from './messages';
import styles from '../../carriers-additional.module.less';

export const OldByoaCallToAction = ({ openNonWalletActivationModal, onAddCarrier }) => (
  <div className={styles['call-to-action']}>
    <div className={styles['call-to-action-message']}>
      <CallToActionMessage openNonWalletActivationModal={openNonWalletActivationModal} />
    </div>
    <div className={styles['call-to-action-button-container']}>
      <Button className={styles['call-to-action-button']} onClick={onAddCarrier} theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...messages.addCarrier} />
      </Button>
    </div>
  </div>
);
